// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ShopPage from "../pages/Shop/Shop";
const __wvcRoutePaths = ["/ShopPage", "/shop", "/research-products"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["404", "about", "aboutpage", "build-your-pack", "buildyourpackpage", "cart", "cartpage", "checkout", "checkoutpage", "contact", "contactpage", "faq", "faqpage", "home", "homecopypage", "homepage", "landing", "my-account", "myaccountpage", "policies", "policiespage", "post", "quality-coas", "qualitytestingpage", "research-products", "search", "shop", "shoppage", "term"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      <Route path={__wvcRoutePaths[0]} element={<ShopPage />} />
      <Route path={__wvcRoutePaths[1]} element={<ShopPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[2]} element={<ShopPage />} />
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
